import React, { useEffect, useState } from 'react';
import { Car, Calendar, MapPin, Phone, Mail, Star, ChevronRight, Check, Sparkles, Award, AlertCircle } from 'lucide-react';
import Byde from '../Assets/BYD Electric.png'
import MercedesBenzGLE from "../Assets/Mercedes-Benz GLE.jpeg"
import defender from "../Assets/defender.jpeg"
import BMWX7 from "../Assets/BMW X7.jpeg"
import MercedesBenz from "../Assets/Mercedes-Benz E-Class LWB.jpeg"
import RangeRover from "../Assets/Range Rover Velar.jpeg" 
import mercentbenzeclass from "../Assets/Mercedes-Benz E-Class LWB.jpeg"
import audia4 from "../Assets/audi a4 sedan.jpeg"
import Audia8 from "../Assets/Audi A8 L.jpeg"
import bmw7 from "../Assets/BMW 7 Series.jpeg"
import mercentsclass from "../Assets/Mercedes-Benz S-Class.jpeg"
import rover from "../Assets/mercentsclass.jpeg"
import Velfare from "../Assets/Toyota Vellfire.png"
import Porsche from "../Assets/Porsche Cayenn.avif"

const LuxuryCarBooking = () => {
  const [selectedCar, setSelectedCar] = useState(null);
  const [bookingStep, setBookingStep] = useState('browse');
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    pickupDate: '',
    returnDate: '',
    location: ''
  });
  const [formErrors, setFormErrors] = useState({});

  const luxuryCars = [
    {
      id: 1,
      name: 'Mercedes-Benz S-Class',
      variant: 'S 450 4MATIC',
      price: '₹18,999',
      image: mercentsclass,
      features: ['Executive Chauffeur', 'Nappa Leather', 'Burmester Sound'],
      rating: 5.0,
      reviews: 342
    },
    {
      id: 2,
      name: 'BMW 7 Series',
      variant: '740Li M Sport',
      price: '₹17,500',
      image: bmw7,
      features: ['Sky Lounge', 'Bowers & Wilkins', 'Executive Lounge'],
      rating: 4.9,
      reviews: 298
    },
    {
      id: 3,
      name: 'Audi A8 L',
      variant: '60 TFSI Quattro',
      price: '₹19,500',
      image: Audia8,
      features: ['Matrix OLED', 'Valcona Leather', 'Bang & Olufsen'],
      rating: 5.0,
      reviews: 256
    },
    {
      id: 4,
      name: 'Range Rover Autobiography',
      variant: 'LWB P400',
      price: '₹22,000',
      image: rover,
      features: ['Terrain Response', 'Oxford Leather', 'Meridian Audio'],
      rating: 5.0,
      reviews: 412
    },
    // {
    //   id: 5,
    //   name: 'Porsche Panamera',
    //   variant: 'Turbo S E-Hybrid',
    //   price: '₹25,000',
    //   image: 'https://img.autocarpro.in/autocarpro/bc95ae62-c465-4730-816d-3c27442113c1_porsche-panen.jpg?w=750&h=490&q=75&c=1',
    //   features: ['Sport Chrono', 'Burmester 3D', 'PASM Sport'],
    //   rating: 5.0,
    //   reviews: 223
    // },
    // {
    //   id: 6,
    //   name: 'Bentley Flying Spur',
    //   variant: 'W12 First Edition',
    //   price: '₹35,000',
    //   image: 'https://images.ctfassets.net/p77iaapls74f/2gc1vDyTYluX4V95no9pih/571acf5607b011b4a37137f60e5bee83/Flying_Spur.png',
    //   features: ['W12 Engine', 'Diamond Quilting', 'Naim Audio'],
    //   rating: 5.0,
    //   reviews: 289
    // },
    {
      id: 7,
      name: 'Toyota Vellfire',
      variant: 'Hybrid',
      price: '₹15,999',
      image: Velfare,
      features: ['7-Seater Luxury MPV', 'Executive Lounge Seating', 'Premium Rear Entertainment'],
      rating: 4.8,
      reviews: 415
    },
    {
      id: 8,
      name: 'Mercedes-Benz C-Class',
      variant: 'C 300',
      price: '₹12,500',
      image: mercentbenzeclass,
      features: ['Premium Cockpit', 'Burmester® Surround Sound', 'Ambient Lighting'],
      rating: 4.7,
      reviews: 389
    },
    {
      id: 9,
      name: 'Range Rover Velar',
      variant: 'D200',
      price: '₹20,500',
      image: RangeRover,
      features: ['Touch Pro Duo', 'Air Suspension', 'Matrix LED Headlights'],
      rating: 4.9,
      reviews: 267
    },
    {
      id: 10,
      name: 'Mercedes-Benz E-Class LWB',
      variant: 'E 220d',
      price: '₹16,800',
      image: MercedesBenz,
      features: ['Extended Wheelbase', 'Rear Reclining Seats', '4-Zone Climate Control'],
      rating: 5.0,
      reviews: 178
    },
    {
      id: 11,
      name: 'BMW X7',
      variant: 'xDrive40i M Sport',
      price: '₹28,000',
      image: BMWX7,
      features: ['3-Row Luxury SUV', 'Panoramic Sky Lounge', 'Bowers & Wilkins Diamond'],
      rating: 5.0,
      reviews: 195
    },
    {
      id: 12,
      name: 'Porsche Cayenne',
      variant: 'GTS',
      price: '₹32,000',
      image: Porsche,
      features: ['Sport Chrono Package', 'Adaptive Air Suspension', 'Porsche Torque Vectoring'],
      rating: 5.0,
      reviews: 223
    },
    {
      id: 13,
      name: 'Land Rover Defender',
      variant: '110',
      price: '₹26,500',
      image: defender,
      features: ['Terrain Response® 2', 'ClearSight Ground View', 'Wade Sensing'],
      rating: 4.9,
      reviews: 331
    },
    {
      id: 14,
      name: 'Audi A4',
      variant: '45 TFSI Technology',
      price: '₹14,200',
      image: audia4,
      features: ['Audi Virtual Cockpit Plus', 'Twin MMI Touchscreens', 'ADAS Suite'],
      rating: 4.7,
      reviews: 204
    },
    {
      id: 15,
      name: 'Mercedes-Benz GLE',
      variant: '450 4MATIC',
      price: '₹24,500',
      image: MercedesBenzGLE,
      features: ['E-ACTIVE BODY CONTROL', 'MBUX Augmented Reality', 'Energizing Comfort'],
      rating: 4.8,
      reviews: 276
    },
    // {
    //   id: 16,
    //   name: 'BMW 7 Series',
    //   variant: '740i M Sport',
    //   price: '₹19,800',
    //   image: 'https://imgd.aeplcdn.com/1920x1080/n/cw/ec/132513/new-7-series-exterior-right-front-three-quarter.jpeg?isig=0&q=80&q=80',
    //   features: ['Executive Lounge', 'BMW Theatre Screen', 'Sky Lounge Panoramic Roof'],
    //   rating: 4.9,
    //   reviews: 189
    // }
  ];



   useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }, [bookingStep]);

  const validateForm = () => {
    const errors = {};
    
    if (!formData.name.trim()) errors.name = 'Name is required';
    if (!formData.email.trim()) {
      errors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = 'Email is invalid';
    }
    if (!formData.phone.trim()) {
      errors.phone = 'Phone number is required';
    } else if (!/^[0-9]{10}$/.test(formData.phone.replace(/\D/g, ''))) {
      errors.phone = 'Phone number must be 10 digits';
    }
    if (!formData.pickupDate) errors.pickupDate = 'Pickup date is required';
    if (!formData.returnDate) errors.returnDate = 'Return date is required';
    if (!formData.location.trim()) errors.location = 'Location is required';
    
    // Validate dates
    if (formData.pickupDate && formData.returnDate) {
      const pickup = new Date(formData.pickupDate);
      const returnDate = new Date(formData.returnDate);
      if (returnDate < pickup) {
        errors.returnDate = 'Return date must be after pickup date';
      }
    }

    return errors;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    // Format phone number input
    let formattedValue = value;
    if (name === 'phone') {
      formattedValue = value.replace(/\D/g, '').slice(0, 10);
    }
    
    setFormData({
      ...formData,
      [name]: formattedValue
    });
    
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: ''
      });
    }
  };

  const handleBookNow = (car) => {
    setSelectedCar(car);
    setBookingStep('booking');
    setFormErrors({});
  };

  const sendWhatsAppMessage = () => {
    const message = `New Luxury Car Booking!\n\nVehicle: ${selectedCar.name}\nVariant: ${selectedCar.variant}\n\nCustomer Details:\nName: ${formData.name}\nPhone: ${formData.phone}\nEmail: ${formData.email}\n\nBooking Details:\nPickup Date: ${formData.pickupDate}\nReturn Date: ${formData.returnDate}\nLocation: ${formData.location}`;
    
    const encodedMessage = encodeURIComponent(message);
    const whatsappNumber = '+919728115781';
    const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
    
    window.open(whatsappUrl, '_blank');
  };

  const handleSubmitBooking = (e) => {
    e.preventDefault();
    
    const errors = validateForm();
    if (Object.keys(errors).length > 0) {
      setFormErrors(errors);
      return;
    }
    
    setBookingStep('confirmation');
    sendWhatsAppMessage();
  };

  const resetBooking = () => {
    setBookingStep('browse');
    setSelectedCar(null);
    setFormErrors({});
    setFormData({
      name: '',
      email: '',
      phone: '',
      pickupDate: '',
      returnDate: '',
      location: ''
    });
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        {bookingStep === 'browse' && (
          <>
            {/* Hero Section */}
            <div className="text-center mb-10">
              {/* <div className="inline-flex items-center space-x-2 bg-yellow-100 px-4 py-2 rounded-full mb-4">
                <Award className="w-4 h-4 text-yellow-600" />
                <span className="text-yellow-900 font-semibold text-sm">Award-Winning Service</span>
              </div> */}
              <h2 className="text-4xl font-bold text-black mb-3">
                Luxury Vehicle Rentals
              </h2>
              <p className="text-lg text-gray-600">
                India's premium collection of luxury vehicles
              </p>
            </div>

            {/* Stats */}
            {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-10">
              <div className="bg-white rounded-lg p-4 shadow text-center border-2 border-yellow-200">
                <div className="text-2xl font-bold text-yellow-600">16+</div>
                <div className="text-gray-600 text-sm">Vehicles</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow text-center border-2 border-yellow-200">
                <div className="text-2xl font-bold text-yellow-600">5000+</div>
                <div className="text-gray-600 text-sm">Clients</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow text-center border-2 border-yellow-200">
                <div className="text-2xl font-bold text-yellow-600">15+</div>
                <div className="text-gray-600 text-sm">Cities</div>
              </div>
              <div className="bg-white rounded-lg p-4 shadow text-center border-2 border-yellow-200">
                <div className="text-2xl font-bold text-yellow-600">24/7</div>
                <div className="text-gray-600 text-sm">Service</div>
              </div>
            </div> */}

            {/* Car Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {luxuryCars.map((car) => (
                <div
                  key={car.id}
                  className="bg-white rounded-xl overflow-hidden shadow-lg border-2 border-gray-200 hover:border-yellow-400 transition-all hover:shadow-xl"
                >
                  <div className="relative h-44">
                    <img
                      src={car.image}
                      alt={car.name}
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-3 right-3 bg-white px-3 py-1 rounded-full flex items-center space-x-1 shadow">
                      <Star className="w-4 h-4 text-yellow-400 fill-yellow-400" />
                      <span className="text-black text-sm font-bold">{car.rating}</span>
                    </div>
                  </div>
                  
                  <div className="p-5">
                    <h3 className="text-xl font-bold text-black mb-1">{car.name}</h3>
                    <p className="text-gray-600 text-sm mb-3">{car.variant}</p>
                    
                    <div className="space-y-1 mb-4">
                      {car.features.map((feature, idx) => (
                        <div key={idx} className="flex items-center space-x-2">
                          <Check className="w-3 h-3 text-yellow-600" />
                          <span className="text-gray-700 text-sm">{feature}</span>
                        </div>
                      ))}
                    </div>

                    <div className="flex items-center justify-between pt-4 border-t-2 border-gray-200">
                      {/* <div>
                        <p className="text-gray-500 text-xs">Per Day</p>
                        <p className="text-black text-2xl font-bold">{car.price}</p>
                      </div> */}
                      <button
                        onClick={() => handleBookNow(car)}
                        className="bg-yellow-400 text-black px-5 py-2 rounded-lg font-bold hover:bg-yellow-300 transition flex items-center space-x-1"
                      >
                        <span>Book</span>
                        <ChevronRight className="w-4 h-4" />
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </>
        )}

        {bookingStep === 'booking' && selectedCar && (
          <div className="max-w-md mx-auto">
            <button
              onClick={resetBooking}
              className="text-yellow-600 hover:text-yellow-700 mb-5 flex items-center space-x-2 font-semibold"
            >
              <ChevronRight className="w-4 h-4 rotate-180" />
              <span>Back to Fleet</span>
            </button>

            <div className="bg-white rounded-xl shadow-lg border-2 border-yellow-400 p-4">
              <h2 className="text-xl font-bold text-black mb-4">Complete Booking</h2>
              
              <div className="bg-yellow-50 rounded-lg p-3 mb-4 border border-yellow-200">
                <div className="flex items-center space-x-3">
                  <img
                    src={selectedCar.image}
                    alt={selectedCar.name}
                    className="w-20 h-14 object-cover rounded-lg"
                  />
                  <div>
                    <h3 className="text-base font-bold text-black">{selectedCar.name}</h3>
                    <p className="text-gray-600 text-xs">{selectedCar.variant}</p>
                    {/* <p className="text-black text-base font-bold mt-1">{selectedCar.price}/day</p> */}
                  </div>
                </div>
              </div>

              <form onSubmit={handleSubmitBooking} className="space-y-3">
                <div>
                  <label className="block text-black mb-1 font-semibold text-xs">Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    className={`w-full bg-gray-50 border ${formErrors.name ? 'border-red-400' : 'border-gray-300'} rounded-lg px-3 py-2 text-black text-sm focus:outline-none focus:border-yellow-400`}
                    placeholder="Enter your name"
                  />
                  {formErrors.name && (
                    <div className="flex items-center space-x-1 mt-1">
                      <AlertCircle className="w-3 h-3 text-red-500" />
                      <span className="text-red-500 text-xs">{formErrors.name}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-black mb-1 font-semibold text-xs">Phone Number *</label>
                  <div className={`flex items-center bg-gray-50 border ${formErrors.phone ? 'border-red-400' : 'border-gray-300'} rounded-lg focus-within:border-yellow-400`}>
                    <Phone className="w-3 h-3 text-gray-600 ml-3" />
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      className="flex-1 bg-transparent px-2 py-2 text-black text-sm focus:outline-none"
                      placeholder="9876543210"
                    />
                  </div>
                  {formErrors.phone && (
                    <div className="flex items-center space-x-1 mt-1">
                      <AlertCircle className="w-3 h-3 text-red-500" />
                      <span className="text-red-500 text-xs">{formErrors.phone}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-black mb-1 font-semibold text-xs">Email Address *</label>
                  <div className={`flex items-center bg-gray-50 border ${formErrors.email ? 'border-red-400' : 'border-gray-300'} rounded-lg focus-within:border-yellow-400`}>
                    <Mail className="w-3 h-3 text-gray-600 ml-3" />
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="flex-1 bg-transparent px-2 py-2 text-black text-sm focus:outline-none"
                      placeholder="your@email.com"
                    />
                  </div>
                  {formErrors.email && (
                    <div className="flex items-center space-x-1 mt-1">
                      <AlertCircle className="w-3 h-3 text-red-500" />
                      <span className="text-red-500 text-xs">{formErrors.email}</span>
                    </div>
                  )}
                </div>

                <div>
                  <label className="block text-black mb-1 font-semibold text-xs">Pickup Location *</label>
                  <div className={`flex items-center bg-gray-50 border ${formErrors.location ? 'border-red-400' : 'border-gray-300'} rounded-lg focus-within:border-yellow-400`}>
                    <MapPin className="w-3 h-3 text-gray-600 ml-3" />
                    <input
                      type="text"
                      name="location"
                      value={formData.location}
                      onChange={handleInputChange}
                      className="flex-1 bg-transparent px-2 py-2 text-black text-sm focus:outline-none"
                      placeholder="Mumbai, Delhi..."
                    />
                  </div>
                  {formErrors.location && (
                    <div className="flex items-center space-x-1 mt-1">
                      <AlertCircle className="w-3 h-3 text-red-500" />
                      <span className="text-red-500 text-xs">{formErrors.location}</span>
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label className="block text-black mb-1 font-semibold text-xs">Pickup Date *</label>
                    <div className={`flex items-center bg-gray-50 border ${formErrors.pickupDate ? 'border-red-400' : 'border-gray-300'} rounded-lg focus-within:border-yellow-400`}>
                      <Calendar className="w-3 h-3 text-gray-600 ml-3" />
                      <input
                        type="date"
                        name="pickupDate"
                        value={formData.pickupDate}
                        onChange={handleInputChange}
                        className="flex-1 bg-transparent px-2 py-2 text-black text-sm focus:outline-none"
                      />
                    </div>
                    {formErrors.pickupDate && (
                      <div className="flex items-center space-x-1 mt-1">
                        <AlertCircle className="w-3 h-3 text-red-500" />
                        <span className="text-red-500 text-xs">{formErrors.pickupDate}</span>
                      </div>
                    )}
                  </div>

                  <div>
                    <label className="block text-black mb-1 font-semibold text-xs">Return Date *</label>
                    <div className={`flex items-center bg-gray-50 border ${formErrors.returnDate ? 'border-red-400' : 'border-gray-300'} rounded-lg focus-within:border-yellow-400`}>
                      <Calendar className="w-3 h-3 text-gray-600 ml-3" />
                      <input
                        type="date"
                        name="returnDate"
                        value={formData.returnDate}
                        onChange={handleInputChange}
                        className="flex-1 bg-transparent px-2 py-2 text-black text-sm focus:outline-none"
                      />
                    </div>
                    {formErrors.returnDate && (
                      <div className="flex items-center space-x-1 mt-1">
                        <AlertCircle className="w-3 h-3 text-red-500" />
                        <span className="text-red-500 text-xs">{formErrors.returnDate}</span>
                      </div>
                    )}
                  </div>
                </div>

                <button
                  type="submit"
                  className="w-full bg-yellow-400 text-black py-2 rounded-lg font-bold text-sm hover:bg-yellow-300 transition mt-2"
                >
                  Confirm Booking
                </button>
              </form>
            </div>
          </div>
        )}

        {bookingStep === 'confirmation' && selectedCar && (
          <div className="max-w-sm mx-auto">
            <div className="bg-white rounded-xl shadow-lg border-2 border-yellow-400 p-6 text-center">
              <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center mx-auto mb-4">
                <Check className="w-6 h-6 text-black" />
              </div>
              
              <h2 className="text-xl font-bold text-black mb-2">Booking Confirmed!</h2>
              <p className="text-gray-600 text-sm mb-4">
                Your luxury vehicle has been reserved. We'll contact you shortly.
              </p>

              <div className="bg-yellow-50 rounded-lg p-4 mb-4 text-left border border-yellow-200">
                <h3 className="text-base font-bold text-black mb-3 flex items-center space-x-2">
                  <Sparkles className="w-4 h-4 text-yellow-600" />
                  <span>Booking Details</span>
                </h3>
                <div className="space-y-1 text-sm">
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Vehicle:</span>
                    <span className="text-black font-semibold">{selectedCar.name}</span>
                  </div>
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Name:</span>
                    <span className="text-black font-semibold">{formData.name}</span>
                  </div>
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Phone:</span>
                    <span className="text-black font-semibold">{formData.phone}</span>
                  </div>
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Email:</span>
                    <span className="text-black font-semibold">{formData.email}</span>
                  </div>
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Pickup:</span>
                    <span className="text-black font-semibold">{formData.pickupDate}</span>
                  </div>
                  <div className="flex justify-between pb-1 border-b border-yellow-200">
                    <span className="text-gray-600 font-medium">Return:</span>
                    <span className="text-black font-semibold">{formData.returnDate}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600 font-medium">Location:</span>
                    <span className="text-black font-semibold">{formData.location}</span>
                  </div>
                </div>
              </div>

              <div className="space-y-2">
                <button
                  onClick={resetBooking}
                  className="w-full bg-yellow-400 text-black px-6 py-2 rounded-lg font-bold text-sm hover:bg-yellow-300 transition"
                >
                  Book Another Vehicle
                </button>
                <button
                  onClick={sendWhatsAppMessage}
                  className="w-full bg-green-500 text-white px-6 py-2 rounded-lg font-bold text-sm hover:bg-green-600 transition"
                >
                  Open WhatsApp Chat
                </button>
              </div>
            </div>
          </div>
        )}
      </main>
    </div>
  );
};

export default LuxuryCarBooking;